import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "clock",
  "use": "clock-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"clock\"><path fill=\"currentColor\" d=\"M12 0a12 12 0 1 0 12 12A12 12 0 0 0 12 0zm0 21.43A9.43 9.43 0 1 1 21.43 12 9.44 9.44 0 0 1 12 21.43z\" /><path fill=\"currentColor\" d=\"M13.29 5.25h-2.58v7.44l5.08 3.38 1.42-2.14-3.92-2.62V5.25z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol